import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const SvgHammer: FC<IClassname> = ({ className }) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 38.5335C22 38.7103 21.9298 38.8799 21.8048 39.0049C21.6797 39.13 21.5102 39.2002 21.3334 39.2002H9.33335C9.15654 39.2002 8.98697 39.13 8.86195 39.0049C8.73692 38.8799 8.66669 38.7103 8.66669 38.5335V36.5335C8.66669 36.1799 8.80716 35.8408 9.05721 35.5907C9.30726 35.3407 9.6464 35.2002 10 35.2002H20.6667C21.0203 35.2002 21.3594 35.3407 21.6095 35.5907C21.8595 35.8408 22 36.1799 22 36.5335V38.5335Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6667 35.1999H10V33.8665C10 33.5129 10.1405 33.1738 10.3905 32.9237C10.6406 32.6737 10.9797 32.5332 11.3333 32.5332H19.3333C19.687 32.5332 20.0261 32.6737 20.2761 32.9237C20.5262 33.1738 20.6667 33.5129 20.6667 33.8665V35.1999Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3337 19.1999L24.6669 11.8667L29.3338 16.5336L22.0006 23.8668L17.3337 19.1999Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3333 19.2002L16.6667 18.5335C15.4107 17.2802 13.4067 19.2735 14.6667 20.5335L20.6667 26.5335C21.924 27.7908 23.928 25.7948 22.6667 24.5335L22 23.8668"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3333 16.5334L30 17.2C31.2573 18.4574 33.2613 16.4614 32 15.2L26 9.20002C24.744 7.94668 22.74 9.94002 24 11.2L24.6666 11.8667"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6667 20.1987L39.3334 33.8654"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
